/* eslint-disable no-console */
/* eslint-disable max-len */
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useCheckExistFolder from '../../customHooks/useCheckExistFolder';
import { catchErr, fileToObjectUrl } from '../../../../libs/HelperContent';
import { setUploadFile } from '../../../../redux/MediakitRedux';
import useUpdateStorage from '../../../LicenseSubscription/customHooks/useGetStorage';

const useUploadFolder = (pauseFunction, clickedData, setMediaState, setProgress) =>
{
	const { tab } = useParams();
	const parentId = useParams()?.id || '';
	const checkFolderName = useCheckExistFolder();
	const dispatch = useDispatch();
	const openedTab = tab === 'folder' ? 'folderData' : tab === 'shared' ? 'sharedData' : '';
	const userData = useSelector((state:any) => state?.mysession?.session);
	const ownerCompanyId = tab === 'shared' ? clickedData?.companyId : userData?.companyId;
	const setStorageData = useUpdateStorage();

	const uploadFile = useSelector((state:any) => state.mymediakit.uploadFile);

	const uploadFolderFunc = async (fileList:any) =>
	{
		setProgress(true);
		setMediaState({ type: 'setMenuItems', payload: { create: 0 } });
		const filesToUpload:any = [];

		fileList.forEach(async (file) =>
		{
			const objectUrl = await fileToObjectUrl(file);

			filesToUpload.push({ objectUrl, name: file?.name, type: file?.type, size: file?.size, webkitRelativePath: file?.webkitRelativePath, openedTab, parentId });
		});

		const size = fileList?.reduce((total, item) => total + item?.size, 0);
		const singleObjectForFolder:any = { name: fileList[0]?.webkitRelativePath?.split('/')[0], size, type: 'folder', fileList: filesToUpload, openedTab, parentId, ownerCompanyId, parentData: clickedData };

		try
		{
			const checkExist = await checkFolderName([ fileList[0]?.webkitRelativePath?.split('/')[0] ], parentId, 0);

			if (checkExist?.data?.length > 0)
			{
				const replace = await pauseFunction();

				if (replace?.replace === 'cancel')
				{
					setStorageData({ action: 'del', size, ownerCompanyId });

					return;
				}
				else if (replace?.replace === 'yes')
				{
					singleObjectForFolder.updateExist = true;
				}
				else
				{
					singleObjectForFolder.name = fileList[0]?.webkitRelativePath?.split('/')[0].concat('_', new Date().valueOf());
					singleObjectForFolder.updateExist = false;
				}
			}
			dispatch(setUploadFile([ ...uploadFile, singleObjectForFolder ]));
			setTimeout(() => setProgress(false), 500);
		}
		catch (err:any)
		{
			catchErr(err);
			setProgress(false);
		}
	};

	return uploadFolderFunc;
};

export default useUploadFolder;